<template>
  <lx-training-setting display-type='气缸'></lx-training-setting>
</template>

<script>
import TrainingSetting from '@/components/training/TrainingSetting'
export default {
  data () {
    return {
    }
  },

  components: { 'lx-training-setting': TrainingSetting }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/training/CylinderTrainingSetting.vue